// extracted by mini-css-extract-plugin
module.exports = {"info":"quickInfo-module--info--1U1LF"};